import { useMutation } from '@tanstack/react-query';
import { apiInviteClinicAdmin } from 'lib/api/firebase/apis/apis';

export function useInviteClinicAdmin() {
  return useMutation({
    mutationFn: apiInviteClinicAdmin
  });
}
